import { render } from "./MfaSetupView.vue?vue&type=template&id=be84c60e&scoped=true"
import script from "./MfaSetupView.vue?vue&type=script&lang=js"
export * from "./MfaSetupView.vue?vue&type=script&lang=js"

import "./MfaSetupView.vue?vue&type=style&index=0&id=be84c60e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be84c60e"]])

export default __exports__